import { useContext } from 'react'
import { DepartmentContext } from 'egi/app/PartnersLine/components/PartnerDepartments/PartnerDepartments'

const useDepartmentStep = () => useContext(DepartmentContext)

export default useDepartmentStep
